import { baseStoreCreator } from '@/utils/store';

interface useDeductiblesStorePayload {
  userId: string;
}

export const DEFAULT_VALUES: useDeductiblesStorePayload = {
  userId: '',
};

export const useDeductiblesStore = baseStoreCreator<useDeductiblesStorePayload>(DEFAULT_VALUES);

export default useDeductiblesStore;
